import { type ActionEvent, Controller } from "@hotwired/stimulus"

export default class SearchFormController extends Controller {
  static targets = ["dateInput", "experienceInput", "submitButton"]
  declare readonly dateInputTarget: HTMLInputElement
  declare readonly hasInputDateTarget: boolean
  declare readonly experienceInputTarget: HTMLSelectElement
  declare readonly submitButtonTarget: HTMLButtonElement

  blurInput({ target }: ActionEvent): void {
    ;(target as HTMLElement).blur()
  }

  focusDate(): void {
    if (this.hasInputDateTarget) {
      this.dateInputTarget.focus()
    }
  }

  focusExperience(): void {
    this.experienceInputTarget.focus()
  }

  focusSubmit(): void {
    this.submitButtonTarget.focus()
  }
}
